import Link from 'next/link'
import { useCookies } from 'react-cookie'
import urljoin from 'url-join'
import { DivPropType } from '../../components/basic/DivPropsType'
import urls from '../urls'
import { COOKIE_OPT } from '../vars'
import useTranslation from './useTranslation'

const COOKIE_NAME = 'login_after_url'
const SIGN_UP_MODE_CORRECTION = 'CORRECTION'

interface LinkLocalePropsType extends DivPropType {
  href: string
  as?: string
  noLink?: boolean
  externalLink?: boolean
  className?: string
  children?: React.ReactNode
  dataRef?: any
  mode?: any
}

const LinkLocale = ({ dataRef, href, as, noLink, externalLink, children, mode, ...others }: LinkLocalePropsType) => {
  const { locale } = useTranslation()
  const hrefProp = urljoin('/[lang]', href)
  const asProp = urljoin(`/${locale}`, as || href)

  // 쿠키 설정 조건문 개선
  const [cookies, setCookies] = useCookies([COOKIE_NAME])
  if (!noLink && mode === SIGN_UP_MODE_CORRECTION) {
    setCookies(COOKIE_NAME, urls.student.portal.correction.request, COOKIE_OPT)
  }

  return (
    <>
      {noLink ? (
        children
      ) : externalLink ? (
        <a target="_blank" href={href} rel="noopener noreferrer" data-ref={dataRef}>
          {children}
        </a>
      ) : (
        <Link legacyBehavior href={externalLink ? href : hrefProp} as={asProp} data-ref={dataRef} {...others}>
          <a {...others} data-ref={dataRef}>
            {children}
          </a>
        </Link>
      )}
    </>
  )
}

export default LinkLocale
